import { toast } from 'react-toastify';
import { useState, useEffect } from "react";
import { useNavigate, Link } from 'react-router-dom';
import validator from 'validator';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

export default function Register({setCurrentUser}) {

  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
	const navigate = useNavigate ();

  useEffect(() => {
    async function checkPassword() {
      let nbErrors = 0;

      if (password.length >= 8) {
        document.getElementById('li1').className = 'green';
      }
      else {
        document.getElementById('li1').className = 'red';
        nbErrors++;
      }

      if (password.match(/[A-Z]/, 'g')) {
        document.getElementById('li2').className = 'green';
      }
      else {
        document.getElementById('li2').className = 'red';
        nbErrors++;
      }

      if (password.match(/[a-z]/, 'g')) {
        document.getElementById('li3').className = 'green';
      }
      else {
        document.getElementById('li3').className = 'red';
        nbErrors++;
      }

      if (password.match(/[0-9]/, 'g')) {
        document.getElementById('li4').className = 'green';
      }
      else {
        document.getElementById('li4').className = 'red';
        nbErrors++;
      }

      if (password.match(/[.,?!:$@*-+=&#()\[\]]/, 'g')) {
        document.getElementById('li5').className = 'green';
      }
      else {
        document.getElementById('li5').className = 'red';
        nbErrors++;
      }

      if (password === passwordConfirm) {
        document.getElementById('li6').className = 'green';
      }
      else {
        document.getElementById('li6').className = 'red';
        nbErrors++;
      }

      if (nbErrors === 0) {
        document.getElementById('btn_submit').disabled = false;
      }
      else {
        document.getElementById('btn_submit').disabled = true;
      }
    }

    // Check Word
    checkPassword();
  }, [password, passwordConfirm]);

  // compare password requirements
  const handleChangePassword = (e) => {
    let passVal = e.target.value;
    setPassword(passVal);
  }

  // compare password confirm
  const handleComparePassword = (e) => {
    let passConfirmVal = e.target.value;
    setPasswordConfirm(passConfirmVal);
  }

  const handleSubmit = (e) => {
    // Prevent the browser from reloading the page
    e.preventDefault();

    // Get the form data
    const form = e.target;
    const formData = new FormData(form);
    const formJson = JSON.stringify(Object.fromEntries(formData.entries()));

    if (validator.isStrongPassword(form.password.value)) {
      // Send to API
      changePassword(formJson);
    }
    else {
      toast.error((<div>Le mot de passe est invalide, veuillez le modifier : <ul className="small">
          <li>Longueur minimale : 8</li>
          <li>Au moins une majuscule</li>
          <li>Au moins une minuscule</li>
          <li>Au moins un nombre</li>
          <li>Au moins un symbole parmi .,?!:$@*-+=&#()[]</li>
        </ul></div>), {
        autoClose: 5000,
      });
    }
  }

  // Save pwd in DB
  async function changePassword(data) {
    await fetch(process.env.REACT_APP_API_SERVER + '/api/auth/changepwd', { 
      method: 'post', 
      headers: {'Content-Type': 'application/json'},
      body: data 
    })
    .then(response => response.json())
    .then(data => confirmation(data));
    return;
  }

  // Display confirmation message
  const confirmation = (data) => {
    console.log(data);
    if (data.status === 'success') {
      toast.success('Mot de passe modifié 🎉', {
        autoClose: 1000,
        onClose: () => {
          navigate('/');
        }
      });
    }
    else {
			toast.error("Erreur de modification du mot de passe 😱", {
        autoClose: 1000
      });
      console.log("Erreur de modification de pwd");
    }
  }
    
	return(
		<>
			<p>Choisissez un nouveau mot de passe</p>

			<form method="post" onSubmit={handleSubmit}>
        <div className="field">
          <label htmlFor="password">Password : </label>
          <input type={showPassword ? "text" : "password"} id="field_password" name="password" value={password} onChange={e => handleChangePassword(e)} />
          
          <button
            type="button"
            className="password-visibility-button"
            onClick={() => setShowPassword(!showPassword)}
            aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
          >
            <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
          </button>
        </div>

        <div className="field">
          <label htmlFor="password_conf">Confirmation : </label>
          <input type={showPasswordConfirm ? "text" : "password"} id="field_password_conf" name="password_conf" value={passwordConfirm} onChange={e => handleComparePassword(e)} />

          <button
            type="button"
            className="password-visibility-button"
            onClick={() => setShowPasswordConfirm(!showPasswordConfirm)}
            aria-label={showPasswordConfirm ? "Masquer le mot de passe" : "Afficher le mot de passe"}
          >
            <FontAwesomeIcon icon={showPasswordConfirm ? faEyeSlash : faEye} />
          </button>
        </div>

        <ul className='small red'>
          <li id='li1' className='red'>Longueur minimale : 8</li>
          <li id='li2' className='red'>Au moins une majuscule</li>
          <li id='li3' className='red'>Au moins une minuscule</li>
          <li id='li4' className='red'>Au moins un nombre</li>
          <li id='li5' className='red'>Au moins un symbole parmi .,?!:$@*-+=&#()[]</li>
          <li id='li6' className='red'>Confirmation OK</li>
        </ul>

        <div className="field">
          <input type="submit" id="btn_submit" disabled value="Valider" />
        </div>
			</form>
		</>
	);
}